// extracted by mini-css-extract-plugin
module.exports = {"container":"PageIntro_container__BEFOW","intro":"PageIntro_intro__2uSKn"};